export default __webpack_public_path__ + "static/media/line-awesome.09dc3112.ttf";